const SectionIntroStudent = () => {
    return (
        <section className="py-5">
            <div className="container p-3">
                <div className="row align-items-center">
                    <div className="col-lg-6 text-center mb-4">
                        <img src="/assets/image/guide/student/aset panduan siswa poin 1.png" style={{ width: '60%' }} alt="" />
                    </div>
                    <div className="col-lg-6 ps-lg-5">
                        <h1 className="text-blue mb-3 fw-bold">Akses gratis buku <br /> pelajaran resmi</h1>
                        <p>Dapatkan akses buku teks pelajaran dan buku referensi untuk bahan belajar di sekolah dan di rumah langsung dari Pusat Perbukuan, Kemdikbud.</p>
                    </div>
                </div>
                <div className="row align-items-center mt-5">
                    <div className="col-lg-6 ps-lg-5 order-last order-md-first mt-4 mt-md-0">
                        <h1 className="text-blue mb-3 fw-bold">Keuntungan jika <br /> daftar akun</h1>
                        <p>Dengan mendaftar dan login di laman SIBI, adik-adik dapat turut serta melaporkan  hal-hal yang terkait dengan buku seperti keunggulan atau kelemahan buku yang adik-adik baca.</p>
                        <p>Dengan login pada platform laman SIBI, adik-adik dapat juga melihat riwayat baca dan unduhan buku.</p>
                        <p>Di laman SIBI ini, adik-adik dapat ikut serta mengulas dan memberikan komentar pada buku, juga melihat ulasan dari teman-teman yang lainnya.</p>
                    </div>
                    <div className="col-lg-6 text-center">
                        <img src="/assets/image/guide/student/aset panduan siswa poin 2.png" className="w-75" alt="" />
                    </div>
                </div>
                <div className="row align-items-center mt-5">
                    <div className="col-lg-6 text-center mb-4">
                        <img src="/assets/image/guide/student/aset panduan siswa poin 3.png" className="w-100" alt="" />
                    </div>
                    <div className="col-lg-6 ps-lg-5">
                        <h1 className="text-blue mb-3 fw-bold">Beragam buku untuk <br /> dicoba</h1>
                        <p style={{ fontSize: '.95rem' }}>Di laman SIBI ini, tersedia buku-buku dari kurikulum 2013 (K-13), Kurikulum Merdeka, serta buku umum sebagai referensi adik-adik belajar.</p>
                        <p>Belajar pun jadi lebih semangat dengan video animasi, games/permainan, dan simulasi pada buku elektronik interaktif.</p>
                        <p>Rasakan asiknya belajar melalui buku audio, belajar dengan santai di rumah maupun di perjalanan.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SectionIntroStudent